var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPathOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 35,
    viewBox: "0 0 43 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.6298 31.2659C36.1467 31.2659 38.187 29.2255 38.187 26.7086C38.187 24.1917 36.1467 22.1514 33.6298 22.1514C31.1129 22.1514 29.0725 24.1917 29.0725 26.7086C29.0725 29.2255 31.1129 31.2659 33.6298 31.2659Z",
    stroke: "#F09702",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0378 7.75586H28.0884C29.5074 7.75586 30.8682 8.21385 31.8716 9.02907C32.8749 9.8443 33.4386 10.95 33.4386 12.1029C33.4386 13.2558 32.8749 14.3615 31.8716 15.1767C30.8682 15.9919 29.5074 16.4499 28.0884 16.4499H12.0378C10.2641 16.4499 8.56308 17.0224 7.30889 18.0414C6.0547 19.0605 5.3501 20.4426 5.3501 21.8837C5.3501 23.3248 6.0547 24.7069 7.30889 25.726C8.56308 26.745 10.2641 27.3175 12.0378 27.3175H20.7319H28.0884",
    stroke: "#F09702",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPathOrange);
export default __webpack_public_path__ + "static/media/icon-path-orange.64a9f811d4f9abccf645d2a4d009d844.svg";
export { ForwardRef as ReactComponent };